import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import ManagementForm from "~/components/Forms/ManagementForm";
import Button from "~/shared/ui/Fields/Button";
import Modal from "~/shared/ui/Fields/Modal";
import useVersionContextSpecificSet from "~/versionControl/hooks/useVersionContextSpecificSet";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { filteredOptions } from "~/pages/Editor/utils";
import { useGetGuideFileQuery } from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "./Editor.less";

const Editor = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hasPermission } = usePermissions();
  const setData = useSetLocationData();
  const { openModal } = useGetLocationData();
  const handleCloseModal = () => {
    setData("openModal", "");
  };
  const openModalFiles = () => {
    setData("openModal", "Files");
  };

  const { data, refetch } = useGetGuideFileQuery({
    fetchPolicy: "cache-and-network",
  });

  const guideFile = get(data, "UserGuideGetter.getGuideFile", {});

  // VERSION_CONTROL_CAMERA_CFG
  const editorOptionsExclude = get(
    useVersionContextSpecificSet(),
    "page.editor.excludeEditorCodes",
    [],
  );

  const editorOptionsVersionControlMiddleWear = (options) =>
    // VERSION_CONTROL_CAMERA_CFG
    // Убрать фильтр при очистке VCS
    options.filter((option) => {
      return !editorOptionsExclude.includes(option.code);
    });

  const options = editorOptionsVersionControlMiddleWear(
    filteredOptions({ hasPermission }),
  );

  return (
    <div className={s.wrapper_editor}>
      <div className={s.title}>{t("editor.managing_ratings")}</div>
      <div className={s.wrapperButton}>
        {hasPermission("user_guides.getGuideFile") && (
          <Button
            txtBtn={"Руководство пользования порталом"}
            small
            onClick={openModalFiles}
          />
        )}
      </div>
      <div className={s.wrapper_items}>
        {options.map((item) => {
          return (
            <div className={s.item} key={item.id}>
              <div className={s.item__content}>
                {!!item.img && (
                  <img
                    alt={item.code}
                    className={s.item__image}
                    src={item.img}
                  />
                )}
                {!!item.svg &&
                  (() => {
                    const Icon = item.svg;
                    return (
                      <div className={s.item__svg}>
                        <Icon fill={"#d2d9da"} />
                      </div>
                    );
                  })()}
                <div className={s.item__title}>
                  {t(`editor.${item.description_lang_key}`)}
                </div>
              </div>
              <div className={s.button}>
                <Button
                  txtBtn={t("editor.button_go")}
                  orange
                  onClick={() => history.push(item.path)}
                />
              </div>
            </div>
          );
        })}
      </div>

      <Modal
        isOpen={openModal === "Files"}
        title={"Руководство пользования порталом"}
        actionClose={handleCloseModal}
      >
        <ManagementForm
          guideFile={guideFile}
          refetch={refetch}
          setCloseModal={handleCloseModal}
        />
      </Modal>

      <div className={"offset-footer"} />
    </div>
  );
};

export default Editor;
